// module
import * as R from 'ramda'
import { fromEvent } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import hostConf from '$config/frontend'
// setup
import { wappSub } from '$func/subscription'
import { wappSubscription } from '$logic/wapp-communication/helper/subscription-handler'

// TODO: Find a safer way
const validateAction = ({ meta }) => meta?.wappId

fromEvent(window, 'message')
  .pipe(
    filter(R.propEq('origin', hostConf.WAPPS_HOST)),
    map(({ data }) => {
      try {
        return JSON.parse(data)
      } catch (e) {
        return {}
      }
    }),
    filter(validateAction),
  )
  .subscribe(action => {
    wappSub.publish(action)
    wappSubscription.publish(action)
  })
